import React from "react";
import styles from "./user-status-with-switch.module.scss";
import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import { ColoredToggleButton } from "../colored-toggle-button/colored-toggle-button";
import { UserUpdatableStatus } from "@src/types/user-management";
import { IndicatorText } from "../indicator-text/indicator-text";
import { useI18N } from "@src/language/language-context";

interface UserStatusWithSwitchPropTypes {
  text: string;
  status: UserUpdatableStatus;
  setStatus: (userStatus: UserUpdatableStatus) => void;
}

const cssClassName = "user-status-with-switch";

export const UserStatusWithSwitch = ({
  text,
  status,
  setStatus,
}: UserStatusWithSwitchPropTypes) => {
  const i18n = useI18N();

  const texts = {
    label: i18n("modules.userStatusWithSwitch.label"),
    userStatusCannotBeChangedText: i18n(
      "modules.userStatusWithSwitch.userStatusCannotBeChangedText",
    ),
  };

  const returnColor = (status: UserUpdatableStatus) => {
    switch (status) {
      case "ACTIVE":
        return "green";
      case "INACTIVE":
        return "orange";
      case "INITIAL":
        return "blue";
      default:
        return "blue";
    }
  };

  return (
    <div className={styles[cssClassName]}>
      <p className={styles[`${cssClassName}__label`]}>{texts.label}</p>
      <FlexRowContainer horizontalGap={8} justifyContent={"space-between"}>
        <IndicatorText text={text} variant={returnColor(status)} />
        {status === "INITIAL" ? (
          <div className={styles[`${cssClassName}__info-wrapper`]}>
            <IndicatorText
              text={texts.userStatusCannotBeChangedText}
              variant={"info"}
            />
          </div>
        ) : (
          <ColoredToggleButton
            isActive={status === "ACTIVE"}
            handleClick={() =>
              setStatus(
                status === "ACTIVE"
                  ? ("INACTIVE" as UserUpdatableStatus)
                  : ("ACTIVE" as UserUpdatableStatus),
              )
            }
            variant={status === "ACTIVE" ? "green" : "orange"}
          />
        )}
      </FlexRowContainer>
    </div>
  );
};
